import { render, staticRenderFns } from "./setAdmin.vue?vue&type=template&id=f2406464&scoped=true&"
import script from "./setAdmin.vue?vue&type=script&lang=js&"
export * from "./setAdmin.vue?vue&type=script&lang=js&"
import style0 from "./setAdmin.vue?vue&type=style&index=0&id=f2406464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2406464",
  null
  
)

export default component.exports